import React from 'react';

interface Props {
  title:        string;
  subtitle?:    string;
  children:     React.ReactNode;
  onClose:      () => void;
  onConfirm?:   () => void;
  confirmText?: string;
  danger?:      boolean;
  wide?:        boolean;
}

export const Modal: React.FC<Props> = ({
  title, subtitle, children, onClose, onConfirm,
  confirmText = 'Confirm', danger = false, wide = false,
}) => (
  <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
    <div className={`modal-box${wide ? ' wide' : ''}`}>
      <div className="modal-title">{title}</div>
      {subtitle && <div className="modal-sub">{subtitle}</div>}
      {children}
      {onConfirm && (
        <div className="modal-footer">
          <button className="modal-cancel" onClick={onClose}>Cancel</button>
          <button className={`modal-confirm${danger ? ' danger' : ''}`} onClick={onConfirm}>
            {confirmText}
          </button>
        </div>
      )}
    </div>
  </div>
);

export const ConfirmModal: React.FC<{
  title: string; message: string;
  onConfirm: () => void; onCancel: () => void; danger?: boolean;
}> = ({ title, message, onConfirm, onCancel, danger = false }) => (
  <Modal title={title} onClose={onCancel} onConfirm={onConfirm}
    confirmText={danger ? '⚠️ Delete' : 'Confirm'} danger={danger}>
    <p style={{ color: 'var(--text2)', fontSize: 13, lineHeight: 1.6 }}>{message}</p>
  </Modal>
);
